function mountIconSprite() {
  if (document.getElementById('site-icon-sprite')) return;

  const spriteUrl = document.getElementById('icon-sprite-loader')?.dataset?.spriteUrl;
  if (!spriteUrl) return;

  fetch(spriteUrl, { credentials: 'same-origin' })
    .then((response) => {
      if (!response.ok) throw new Error(`Failed to load icon sprite: ${response.status}`);
      return response.text();
    })
    .then((spriteMarkup) => {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = spriteMarkup.trim();

      const spriteSvg = wrapper.querySelector('svg');
      if (!spriteSvg) throw new Error('Icon sprite markup did not contain an SVG root');

      spriteSvg.id = 'site-icon-sprite';
      spriteSvg.setAttribute('aria-hidden', 'true');
      spriteSvg.setAttribute('focusable', 'false');
      spriteSvg.setAttribute('width', '0');
      spriteSvg.setAttribute('height', '0');
      spriteSvg.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');

      document.body.insertAdjacentElement('afterbegin', spriteSvg);
    })
    .catch((error) => console.error(error));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountIconSprite);
} else {
  mountIconSprite();
}

window.addEventListener('load', mountIconSprite);
